module.exports = __webpack_public_path__ + "img/shot_bigtx112801.71fce2e2.png";